import { Component, OnDestroy, ViewChild, ChangeDetectionStrategy} from "@angular/core";
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IPortfolioNotes } from "@irb/irb-editors/irb-editors.model";
import { IrbEditorsService } from "@irb/irb-editors/irb-editors.service";

@Component({ standalone: false,
  selector: "irb-grid-archive-cell",
  template: `@if (archieveButton) {
  <button #archiveButton (click)="getValue()" class="gray-button-note">Archive</button>
}
@if (activeButton) {
  <button #activeButton (click)="getActiveValue()" class="gray-button-note">Activate</button>
}
`,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ArchiveCellComponent implements ICellRendererAngularComp, OnDestroy {
  params: any;
  archieveButton: boolean = false;
  activeButton: boolean = false;
  _removeActiveButton: IPortfolioNotes;
  @ViewChild("archiveButton") archiveButton: any;
  @ViewChild("activeButtonState") activeButtonState: any;

  constructor(public ies: IrbEditorsService) {}

  agInit(params: any) {
    this.params = params;
    this.doNotShowActive(params);
    this.doNotShowArchive(params);
  }

  ngOnDestroy(): void {}

  refresh(): boolean {
    return false;
  }

  /*invokeParentMethod() {
    this.params.data.isArchive = false;
    if (typeof !this.params.data.isArchive) {
      this.archieveButton = true;
      //this._disableDelete=this.params.disableDelete(this.params);
    }
  }*/

  doNotShowActive(params: any) {
    if (!params.data.isArchive) {
      this.archieveButton = true;
      this.params.api.stopEditing();
    }
  }

  doNotShowArchive(params: any){
    if (params.data.isArchive) {
      this.activeButton = true;
      this.params.api.stopEditing();
    }
  }

  getValue(): any {
    if(this.params?.context?.componentParent?.onArchive) {
      this.activeButton = true;
      this.params?.context?.componentParent?.onArchive(this.params);
    }
      this.params.context.componentParent.updateRow(this.params);
  }

  getActiveValue(): any {
    if(this.params?.context?.componentParent?.onArchive) {
      this.archieveButton = true;
      this.params?.context?.componentParent?.onArchive(this.params);
      
    }
    this.params?.context?.componentParent?.updateRowArchive(this.params);
  }

  /*get removeActiveButton() {
    return this._removeActiveButton;
  }

  set removeActiveButton(newRemoveIPortfolioNotes: IPortfolioNotes) {
    this._removeActiveButton = newRemoveIPortfolioNotes;
  }*/
}
